import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'glxy-none-selected-input-filter-input',
  template: ` <p>{{ 'GALAXY.FILTER.CHIP.INVALID_FILTER_TYPE' | translate }}</p> `,
  providers: [],
  imports: [CommonModule, TranslateModule],
  standalone: true,
})
export class GalaxyNoneSelectedFilterInputComponent {}
